<template>
    <div class="bar shadowBottom darker bg-lightest d-flex justify-content-between align-items-center border-bottom-light">
        <div class="d-flex align-items-center flex-grow-1 h-100">
            <companies v-if="showCompanyPicker"></companies>
            <search v-if="showSearch"></search>
        </div>
        <user></user>
    </div>
</template>

<script>
    import { mapActions } from 'vuex'
    import Companies from './Companies'
    import Search from './Search'
    import User from './User'

    export default {
        created: function() {
            this.init();
        },
        computed: {
            showCompanyPicker: function () {
                return true
            },
            showSearch: function () {
                // hide to viewer
                return !this.accessPermissionFilter(['viewer'])
            },
        },
        methods: {
            ...mapActions([
                'refreshAccountData',
            ]),
            async init() {
                // if(this.$route.name != "error.logout"){
                //   await this.refreshAccountData();
                // }
            }
        },
        components: {
            Companies,
            Search,
            User
        }
    }
</script>

<style lang="scss">
    @import '../../assets/scss/_variables.scss';

    .bar {
        // height: 6vh;
        // line-height: 6vh;
        height: 45px;
        line-height: 45px;

    }
</style>



// WEBPACK FOOTER //
// Bar.vue?2021bf64